import { Footer } from "./Footer";
export default Footer;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/Footer/index.js